import { NgModule } from '@angular/core';
import { AutofocusDirective } from './AutofocusDirective';
import { ClickOutsideDirective } from './ClickOutsideDirective';
import { ContenteditableValueAccessor } from './ContentEditable';
import { TranslateDirective } from './TranslateDirective';
@NgModule({
  declarations: [
    ClickOutsideDirective,
    AutofocusDirective,
    ContenteditableValueAccessor,
    TranslateDirective,
  ],
  imports: [],

  exports: [
    ClickOutsideDirective,
    AutofocusDirective,
    ContenteditableValueAccessor,
    TranslateDirective,
  ],

  providers: [],
})
export class DirectiveModule {}
